<template>
  <div class="div-input">
    <div class="display-only" v-if="isDisplay"></div>
    <div :class="['input-custom', { error: isValidate }]">
      <label :class="[{ 'd-none': noHeader }]" v-if="textFloat">
        {{ textFloat }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>
      <div class="option" v-if="textOption">
        <b-col class="pl-0" cols="5">
          <div class="btn-group ml-2 mb-1" role="group">
            <button
              type="button"
              class="btn btn-secondary"
              @click="handleChangeAlign(alignList[0].id)"
            >
              <font-awesome-icon icon="align-left" />
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="handleChangeAlign(alignList[1].id)"
            >
              <font-awesome-icon icon="align-justify" />
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="handleChangeAlign(alignList[2].id)"
            >
              <font-awesome-icon icon="align-right" />
            </button>
          </div>
        </b-col>
        <b-col cols="4" class="px-1">
          <InputSelect
            v-if="textOption"
            name="size"
            :options="textSizeList"
            valueField="id"
            textField="name"
            v-model="textOption.Size"
            @onDataChange="handleChangeSize"
          />
        </b-col>
        <b-col class="pl-0 pt-1">
          <input
            v-if="textOption"
            v-model="textOption.Color"
            type="color"
            value="#000000"
        /></b-col>
      </div>

      <textarea
        :class="['custom-input']"
        :placeholder="placeholder"
        :name="name"
        :rows="rows"
        :required="required"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @change="onDataChange"
        @paste="$emit('onPaste', $event)"
        @keyup="$emit('onKeyup', $event)"
        v-bind:style="[
          textOption ? { color: textOption.Color } : { color: '#404040' },
        ]"
        id="textReply"
      ></textarea>
    </div>
    <img :src="img" alt="logo-lang" v-if="img" class="logo-lang" />
    <span v-if="detail" class="text-desc pl-2">{{ detail }}</span>
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">กรุณากรอกข้อมูล</span>
    </div>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";

export default {
  components: {
    InputSelect,
  },
  props: {
    textFloat: {
      required: false,
      type: String,
    },
    placeholder: {
      required: true,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    detail: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
    },
    value: {
      required: false,
      type: String | Number,
    },
    rows: {
      required: false,
      type: String | Number,
    },
    isDisplay: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    },
    img: {
      required: false,
      type: String,
    },
    noHeader: {
      required: false,
      type: Boolean,
    },
    noHeader: {
      required: false,
      type: Boolean,
    },
    textOption: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      alignList: [],
      textSizeList: [],
    };
  },
  created() {
    if (this.textOption) {
      this.getTextAlign();
      this.getTextSize();
    }
  },
  methods: {
    async getTextAlign() {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/TextAlign`)
        .then((data) => {
          if (data.result == 1) {
            this.alignList = data.detail;
          }
        });
    },
    async getTextSize() {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/TextSize`)
        .then((data) => {
          if (data.result == 1) {
            this.textSizeList = data.detail;
          }
        });
    },
    onDataChange(event) {
      this.$emit("onDataChange", event.target.value);
    },
    handleChangeSize(value) {
      this.textOption.Size = value;
      // let objtxt = document.getElementById("textReply");
      // if (value == 1) {
      //   objtxt.style.fontSize = "xx-small";
      // } else {
      //   objtxt.style.fontSize = "xx-large";
      // }
    },
    handleChangeAlign(value) {
      this.textOption.Align = value;
      let objtxt = document.getElementById("textReply");
      if (value == 1) {
        objtxt.style.textAlign = "left";
      } else if (value == 2) {
        objtxt.style.textAlign = "center";
      } else {
        objtxt.style.textAlign = "right";
      }
    },
  },
};
</script>

<style scoped>
.div-input {
  margin-bottom: 15px;
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
}
.input-custom > label {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
.input-custom > textarea {
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 5px 10px;
}
.input-custom > textarea:focus {
  border: 1px solid #404040;
}
.input-custom.error > textarea {
  border-color: red !important;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(22, 39, 74, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(22, 39, 74, 0.4);
}
::placeholder {
  color: rgba(22, 39, 74, 0.4);
}
.custom-input {
  display: block;
  border: none;
  width: 100%;
}
.text-desc {
  color: #404040;
  font-size: 0.8rem;
}
.display-only {
  position: absolute;
  z-index: 5000;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.option {
  display: inline-flex;
  width: 80%;
  height: 40px;
}
.input-right {
  text-align: right;
}
.input-center {
  text-align: right;
}
.input-left {
  text-align: right;
}
@media (max-width: 767.98px) {
  /* .div-input {
    margin-top: 0;
  } */
  .input-custom > label {
    font-size: 15px;
  }
}
</style>
